var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentData)?_c('div',{staticClass:"app-center",style:({top:_vm.systemConfig?.theme_type === 4?'78px':'48px'})},[_c('PageParser',{attrs:{"customComponentData":_vm.componentData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }